import { useMemo } from "react";
import { useAuthState } from "../Context";

export const useWebinarPricing = (webinar) => {
  const { user } = useAuthState();

  const pricingInfo = useMemo(() => {
    if (!webinar || webinar.type !== "PAID") return null;

    const isPremiumUser = user?.membership === "PREMIUM";
    const hasPrice = webinar.price !== null && webinar.price !== undefined;
    const hasNormalPrice =
      webinar.normalPrice !== null && webinar.normalPrice !== undefined;
    const hasMemberPrice =
      webinar.memberPrice !== null && webinar.memberPrice !== undefined;

    if (!hasPrice) return null;

    const now = new Date();
    const scheduledAt = new Date(webinar.scheduledAt);
    const isBeforeScheduled = now < scheduledAt;
    const hasAvailableSlots =
      !webinar.maxParticipants ||
      (webinar.participantCount || 0) < webinar.maxParticipants;
    const isAvailable = isBeforeScheduled && hasAvailableSlots;

    const calculateDiscount = (currentPrice, originalPrice) => {
      if (!originalPrice || originalPrice === 0) return 0;
      return Math.round(((originalPrice - currentPrice) / originalPrice) * 100);
    };

    let displayPrice = webinar.price;
    let displayOriginalPrice = null;
    let discountPercentage = 0;
    let showMemberBadge = false;

    if (isPremiumUser && hasMemberPrice) {
      displayPrice = webinar.memberPrice;
      showMemberBadge = true;

      if (hasNormalPrice) {
        displayOriginalPrice = webinar.normalPrice;
        discountPercentage = calculateDiscount(
          webinar.memberPrice,
          webinar.normalPrice,
        );
      } else if (webinar.price !== webinar.memberPrice) {
        displayOriginalPrice = webinar.price;
        discountPercentage = calculateDiscount(
          webinar.memberPrice,
          webinar.price,
        );
      }
    } else {
      if (hasNormalPrice) {
        displayOriginalPrice = webinar.normalPrice;
        discountPercentage = calculateDiscount(
          webinar.price,
          webinar.normalPrice,
        );
      }
    }

    return {
      displayPrice,
      displayOriginalPrice,
      discountPercentage,
      showMemberBadge,
      hasPrice: true,
      isAvailable,
      participantCount: webinar.participantCount || 0,
      maxParticipants: webinar.maxParticipants,
    };
  }, [webinar, user?.membership]);

  return pricingInfo;
};
